export const GET_DATES = 'GET_DATES'
export const CUSTOMER_MODE = 'CUSTOMER_MODE'
export const DEFAULT_CUSTOMER_MODE = 'DEFAULT_CUSTOMER_MODE'
export const PROMO_CODES = 'PROMO_CODES'
export const SET_YEAR = 'SET_YEAR'
export const CONVERSION = 'CONVERSION'
export const CUSTOMERBEHAVIOUR = 'CUSTOMERBEHAVIOUR'

export const VENDOR_DISCOUNTS = 'VENDOR_DISCOUNTS'

export const VENDOR_OFFERS = 'VENDOR_OFFERS'
export const VENDOR_PROMOTIONS = 'VENDOR_PROMOTIONS'

export const OFFLINE_PRODUCT_FILTERS = 'OFFLINE_PRODUCT_FILTERS'
export const ONLINE_PRODUCT_FILTERS = 'ONLINE_PRODUCT_FILTERS'
export const ONLINE_FILTERED_USERS = 'ONLINE_FILTERED_USERS'
export const OFFLINE_FILTERED_USERS = 'OFFLINE_FILTERED_USERS'

export const GET_TOTAL_PAGES = 'GET_TOTAL_PAGES'
export const GET_TOTAL_SPENT = 'GET_TOTAL_SPENT'
export const GET_QUERY = 'GET_QUERY'
export const GET_AB_QUERY = 'GET_AB_QUERY'
export const GET_TOTAL_PAGES_LOYALTY = 'GET_TOTAL_PAGES_LOYALTY'

export const LOYALTY_LEVELS = 'LOYALTY_LEVELS'
export const LOYALTY_OFFERS = 'LOYALTY_OFFERS'
export const MONITORING_NAMES = 'MONITORING_NAMES'
export const EMPTY_MONITORING_NAMES = 'EMPTY_MONITORING_NAMES'

export const GET_CONDITIONAL_CUSTOMER_COUNT = 'GET_CONDITIONAL_CUSTOMER_COUNT'
export const SAVE_CONDITIONAL_CAMPAIGN = 'SAVE_CONDITIONAL_CAMPAIGN'
export const UPDATE_SAVE_CONDITIONAL_CAMPAIGN = 'UPDATE_SAVE_CONDITIONAL_CAMPAIGN'
export const UPDATE_SAVE_CONDITIONAL_CAMPAIGN_BY_ID = 'UPDATE_SAVE_CONDITIONAL_CAMPAIGN_BY_ID'
export const GET_CONDITIONAL_CUSTOMER_NUMBERS = 'GET_CONDITIONAL_CUSTOMER_NUMBERS'
export const GET_ALL_SAVE_CONDITIONAL_CAMPAIGN = 'GET_ALL_SAVE_CONDITIONAL_CAMPAIGN'
export const DELETE_SAVE_CAMPAIGN = 'DELETE_SAVE_CAMPAIGN'
export const UPDATE_CLUSTER_STATUS = 'UPDATE_CLUSTER_STATUS'
